export type FooterProps = React.HTMLAttributes<HTMLElement> & {
  children: React.ReactNode | string
  className?: string
}

const Footer = ({children, className, ...restProps}: FooterProps) => {
  return (
    <div {...restProps} className={className}>
      {children}
    </div>
  )
}
Footer.displayName = 'ControlGroup.Footer'

export default Footer
